import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProgrammesService } from '../../../services/programmes.service';
import { Programme } from '../../../models/programme.model';
import $ from "jquery";

@Component({
  selector: 'programmes-modal-component',
  templateUrl: './programmes.modal.component.html',
  styleUrls: ['./programmes.modal.component.scss']
})

export class ProgrammesModalComponent implements OnInit {
  @Input() programme: Programme;
  form: FormGroup;
  service: ProgrammesService;
  afficherMessage: boolean = false;
  isLoading: boolean = false;
  isNewProgramme: boolean;
  codeValide: boolean = true;

  constructor(public bsModalRef: BsModalRef,
    fb: FormBuilder,
    service: ProgrammesService) {
    this.form = fb.group({
      "programmeId": [""],
      "code": ["", Validators.required],
      "nom": ["", Validators.required],
      "diplome": ["", Validators.required],
      "isActif": [""],
    });
    this.service = service;
  }

  ngOnInit() {
    if (!this.programme) {
      this.isNewProgramme = true;
      this.programme = {
        programmeId: -1,
        code: '',
        nom: '',
        diplome: '',
        isActif: true,
      };
    } else {
      this.isNewProgramme = false;
    }

  }

  verifierSiCodeValide(code: string): void {
    if (code == " ") {
      this.form.controls.code.setValue("");
      code = "";
    }
     // si c'est un nouveau programme, verifier si le code existe deja...
    if (code != "") {
      this.service.programmeExist(code).subscribe(x => {
        if (x == true) {
          this.afficherMessage = true;
          this.codeValide = false;
        }
        else {
          this.afficherMessage = false;
          this.codeValide = true;
        }
      });
    }
  }

  onSubmit() {
    if (!this.form.dirty) {
      this.bsModalRef.hide();
      return;
    }
    if (this.afficherMessage == true) return;
    this.programme.nom = this.programme.nom.trim();
    this.isLoading = true;
    console.log("PROGRAMME : ", this.programme);
    if (!this.isNewProgramme) {
      this.service.updateProgramme(this.programme.programmeId, this.programme).subscribe(() => {
        this.isLoading = false;
        this.bsModalRef.hide();
      });
    } else {
      this.service.createProgramme(this.programme).subscribe(() => {
        this.isLoading = false;
        this.bsModalRef.hide();
      });
    }
  }

  supprimer() {
    this.isLoading = true;
    console.log(">> ", this.programme);
    this.service.deleteProgramme(this.programme.programmeId).subscribe(() => {
      this.isLoading = false;
      this.bsModalRef.hide();
    });
  }

  cancel() {
    this.form.reset();
    this.bsModalRef.hide();
  }
}
